(function(){
  // Decisión de marca (Nico, 16 jul 2026): las animaciones se ven SIEMPRE, ignorando prefers-reduced-motion del SO
  var reducedMotion=false;

  // drawers + overlay (con gestión de foco accesible)
  var overlay=document.querySelector('[data-overlay]');
  // #MenuDrawer se renderiza dentro de la sección del header (position:sticky;z-index:30), que crea un
  // stacking context y ATRAPA el drawer por debajo del overlay (z-40) aunque el drawer sea z-50 → el menú
  // se veía "lavado" (el overlay azul con blur pintaba encima). CartDrawer y SearchModal no sufren esto
  // porque cuelgan del <body>. Movemos el menú al <body> para que compita en el nivel raíz igual que ellos.
  var _menuDrawer=document.getElementById('MenuDrawer');
  if(_menuDrawer&&_menuDrawer.parentElement!==document.body)document.body.appendChild(_menuDrawer);
  var lastFocus=null,activeTrigger=null,openPanel=null;
  function focusablesOf(el){return el.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])')}
  function open(sel,trigger){
    var el=document.querySelector(sel);if(!el||el===openPanel)return;
    lastFocus=trigger||document.activeElement;activeTrigger=trigger||null;openPanel=el;
    el.classList.add('is-open');overlay&&overlay.classList.add('is-open');document.body.style.overflow='hidden';
    // los mp4 ex-GIF del panel (p.ej. Etnalia en el drawer) pueden llegar pausados si el panel nació oculto
    el.querySelectorAll('video[autoplay]').forEach(function(v){var p=v.play();if(p&&p.catch)p.catch(function(){})});
    // "la página se aparta" SOLO en el menú (estilo Be Yours); el carrito abre sin mover el fondo
    if(sel==='#MenuDrawer')document.body.classList.add('fh-push-right');
    if(activeTrigger&&activeTrigger.setAttribute)activeTrigger.setAttribute('aria-expanded','true');
    var f=focusablesOf(el);
    var preferred=el.querySelector('[data-search-input]')||f[0]||el;
    setTimeout(function(){preferred.focus&&preferred.focus()},20);
    el._trap=function(ev){
      if(ev.key!=='Tab'||!f.length)return;
      var first=f[0],last=f[f.length-1];
      if(ev.shiftKey&&document.activeElement===first){ev.preventDefault();last.focus()}
      else if(!ev.shiftKey&&document.activeElement===last){ev.preventDefault();first.focus()}
    };
    el.addEventListener('keydown',el._trap);
  }
  function closeAll(){
    document.querySelectorAll('.drawer.is-open,.mega.is-open,.fh-modal.is-open').forEach(function(el){el.classList.remove('is-open')});
    overlay&&overlay.classList.remove('is-open');document.body.style.overflow='';
    document.body.classList.remove('fh-push-right');
    // al cerrar el menú, volver al panel raíz para la próxima apertura
    document.querySelectorAll('[data-mnav]').forEach(function(nav){
      nav.classList.remove('is-sub');
      nav.querySelectorAll('.mnav__panel--sub.is-active').forEach(function(p){p.classList.remove('is-active')});
      nav.querySelectorAll('[data-mnav-open][aria-expanded="true"]').forEach(function(b){b.setAttribute('aria-expanded','false')});
    });
    if(openPanel&&openPanel._trap){openPanel.removeEventListener('keydown',openPanel._trap);openPanel._trap=null}
    if(activeTrigger&&activeTrigger.setAttribute)activeTrigger.setAttribute('aria-expanded','false');
    var back=lastFocus;openPanel=null;activeTrigger=null;lastFocus=null;
    if(back&&back.focus)back.focus();
  }
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-open]');
    if(t){
      e.preventDefault();open(t.getAttribute('data-open'),t);
      return
    }
    if(e.target.closest('[data-close]')||e.target===overlay){closeAll()}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll()});

  // menú móvil: paneles deslizantes (estilo Be Yours)
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-mnav-open]');
    if(o){
      var nav=o.closest('[data-mnav]'),p=document.getElementById(o.getAttribute('data-mnav-open'));
      if(nav&&p){nav.classList.add('is-sub');p.classList.add('is-active');o.setAttribute('aria-expanded','true');p.scrollTop=0}
      return;
    }
    var bk=e.target.closest('[data-mnav-back]');
    if(bk){
      var nav2=bk.closest('[data-mnav]');
      nav2.classList.remove('is-sub');
      nav2.querySelectorAll('.mnav__panel--sub.is-active').forEach(function(x){x.classList.remove('is-active')});
      nav2.querySelectorAll('[data-mnav-open][aria-expanded="true"]').forEach(function(b){b.setAttribute('aria-expanded','false')});
    }
  });

  // hero carousel
  document.querySelectorAll('[data-carousel]').forEach(function(c){
    var slides=c.querySelectorAll('[data-slide]'),dots=c.querySelectorAll('[data-dot]'),toggle=c.querySelector('[data-carousel-toggle]'),i=0,n=slides.length,timer,paused=reducedMotion;
    if(n<2)return;
    // el saliente se apaga en .28s y el entrante sube en .55s: nunca se leen dos titulares a la vez
    function go(k){i=(k+n)%n;slides.forEach(function(s,j){s.style.transitionDuration=j===i?'.55s':'.28s';s.style.opacity=j===i?1:0;s.style.pointerEvents=j===i?'auto':'none';s.setAttribute('aria-hidden',j===i?'false':'true')});dots.forEach(function(d,j){d.classList.toggle('is-active',j===i);if(j===i)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current')});
      // vídeo de la diapositiva: solo suena (en silencio) la activa
      slides.forEach(function(s,j){var v=s.querySelector('video');if(!v)return;if(j===i&&!reducedMotion){var p=v.play();if(p&&p.catch)p.catch(function(){})}else v.pause()})}
    function updateToggle(){if(!toggle)return;toggle.textContent=paused?'▶':'Ⅱ';toggle.setAttribute('aria-pressed',paused?'true':'false');toggle.setAttribute('aria-label',paused?'Reanudar carrusel':'Pausar carrusel')}
    function auto(){clearInterval(timer);if(paused)return;timer=setInterval(function(){go(i+1)},6000)}
    c.querySelectorAll('[data-prev]').forEach(function(b){b.addEventListener('click',function(){go(i-1);auto()})});
    c.querySelectorAll('[data-next]').forEach(function(b){b.addEventListener('click',function(){go(i+1);auto()})});
    dots.forEach(function(d,j){d.addEventListener('click',function(){go(j);auto()})});
    if(toggle)toggle.addEventListener('click',function(){paused=!paused;updateToggle();auto()});
    // swipe táctil
    var sx=null;
    c.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
    c.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>40){go(dx<0?i+1:i-1);auto()}sx=null},{passive:true});
    // pausar en hover/foco (WCAG 2.2.2)
    c.addEventListener('mouseenter',function(){clearInterval(timer)});
    c.addEventListener('mouseleave',auto);
    c.addEventListener('focusin',function(){clearInterval(timer)});
    c.addEventListener('focusout',auto);
    go(0);updateToggle();auto();
  });

  // galería PDP: miniaturas (clic) + swipe en móvil cambian la imagen principal
  (function(){
    var wrap=document.querySelector('#MainImage');
    var track=wrap&&wrap.querySelector('[data-gallery-track]');
    if(!wrap||!track)return;
    var slides=Array.prototype.slice.call(track.children);
    if(!slides.length)return;
    var thumbs=Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));
    var cont=thumbs.length?thumbs[0].parentElement:null; // .pdp-thumbs
    var heroVideo=wrap.querySelector('[data-hero-video]'); // portada autoplay mudo (overlay sobre la 1ª slide)
    var dots=Array.prototype.slice.call(wrap.querySelectorAll('.pdp-dot'));
    var navEls=[wrap.querySelector('[data-gallery-prev]'),wrap.querySelector('[data-gallery-next]'),wrap.querySelector('[data-gallery-dots]')];
    // solo vídeos con controles: las animaciones mudas (ex-GIF, data-fh-lazy-video) no deben ocultar flechas/puntos
    function slideIsVideo(i){return !!(slides[i]&&slides[i].querySelector('video[controls]'))}
    var idx=0;
    function setIndex(i){
      if(i<0||i>=slides.length)return;
      idx=i;
      // desliza el track (todo ya en el DOM y precargado → instantáneo + animado)
      track.style.transform='translateX(-'+(i*100)+'%)';
      // el vídeo de portada solo se ve en la 1ª slide
      if(heroVideo){
        if(i===0){heroVideo.style.display='';var pr=heroVideo.play&&heroVideo.play();if(pr&&pr.catch)pr.catch(function(){})}
        else{heroVideo.style.display='none';if(heroVideo.pause)heroVideo.pause()}
      }
      // pausar los vídeos-media que quedan fuera de pantalla
      for(var k=0;k<slides.length;k++){if(k!==i){var vk=slides[k].querySelector('video');if(vk&&vk.pause)vk.pause()}}
      var isVid=slideIsVideo(i);
      thumbs.forEach(function(b,j){b.classList.toggle('is-active',j===i)});
      dots.forEach(function(d,j){d.classList.toggle('is-active',j===i)});
      // con vídeo-media a la vista: fuera flechas/puntos (no tapar sus controles). En los
      // extremos, se oculta la flecha que no lleva a ningún sitio (izq en la 1ª, dcha en la última).
      if(navEls[0])navEls[0].style.display=(isVid||i===0)?'none':'';
      if(navEls[1])navEls[1].style.display=(isVid||i===slides.length-1)?'none':'';
      if(navEls[2])navEls[2].style.display=isVid?'none':'';
      // centrar el thumb activo dentro de su fila (nunca hace scroll de la página)
      var t=thumbs[i];
      if(t&&cont&&cont.scrollWidth>cont.clientWidth+4){
        cont.scrollTo({left:t.offsetLeft-(cont.clientWidth-t.offsetWidth)/2,behavior:'smooth'});
      }
    }
    thumbs.forEach(function(btn,i){btn.addEventListener('click',function(){setIndex(i)})});
    setIndex(0);
    // slides 3+ nacen lazy para no competir con el LCP; en idle tras el load se precargan
    // todas → cuando el usuario llega a swipear ya están (carrusel instantáneo intacto)
    window.addEventListener('load',function(){
      var warm=function(){track.querySelectorAll('img[loading="lazy"]').forEach(function(im){im.loading='eager'})};
      if('requestIdleCallback' in window){requestIdleCallback(warm,{timeout:3000})}else{setTimeout(warm,1500)}
    });
    // flechas (con límites, sin vuelta) y puntos clicables
    function nav(d){var t=idx+d;if(t<0||t>=slides.length)return;setIndex(t)}
    if(navEls[0])navEls[0].addEventListener('click',function(){nav(-1)});
    if(navEls[1])navEls[1].addEventListener('click',function(){nav(1)});
    dots.forEach(function(d,j){d.addEventListener('click',function(){setIndex(j)})});
    // Swipe horizontal sobre la imagen principal (móvil). Listeners pasivos: el scroll
    // vertical de la página sigue funcionando; solo actuamos si el gesto es claramente horizontal.
    var x0=null,y0=null;
    wrap.addEventListener('touchstart',function(e){var t=e.touches[0];x0=t.clientX;y0=t.clientY;},{passive:true});
    wrap.addEventListener('touchend',function(e){
      if(x0===null)return;
      var t=e.changedTouches[0],dx=t.clientX-x0,dy=t.clientY-y0;
      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.4){
        nav(dx<0?1:-1);
      }
      x0=null;y0=null;
    },{passive:true});
  })();

  // carrito AJAX: re-render del drawer + contador del header
  function applyCartHTML(html){
    var d=document.createElement('div');d.innerHTML=html;
    var fresh=d.querySelector('#CartDrawer-src');var cur=document.querySelector('#CartDrawer');
    if(fresh&&cur){cur.innerHTML=fresh.innerHTML}
    var count=fresh&&fresh.getAttribute('data-cart-count');
    if(count!==null){document.querySelectorAll('[data-cart-count-text]').forEach(function(el){
      var badge=el.closest('.fh-cart-badge');
      if(badge)badge.classList.toggle('is-empty',count==='0');
      if(el.textContent!==count){
        el.textContent=count;
        if(!reducedMotion){el.classList.remove('fh-count-pop');void el.offsetWidth;el.classList.add('fh-count-pop');
          // el icono del carrito da un saltito a la vez (fh-gustos.css; se apaga en Configuración del tema → Gustos)
          var lk=el.closest('.fh-cart-link');if(lk){lk.classList.remove('fh-cart-hop');void lk.offsetWidth;lk.classList.add('fh-cart-hop')}}
      }
    })}
  }
  function refreshCart(){
    return fetch('/?section_id=cart-drawer').then(function(r){return r.text()}).then(applyCartHTML);
  }
  // Para quien cambia el carrito desde fuera de este archivo (el pop-up de bienvenida, al aplicar su código).
  window.fhRefreshCart=refreshCart;
  // Para repintar con un HTML ya recibido (add.js con `sections`): «Completa tu ritual» del carrito (fh-carrito.js)
  window.fhApplyCartHTML=applyCartHTML;

  {
    var fhAdd=function(f){
      var btn=f.querySelector('[type="submit"]');
      var req;
      // Oferta Etnalia: la opción seleccionada puede añadir varios productos a la vez
      var bundle=document.querySelector('.fh-bundle-option.is-selected[data-items]');
      if(bundle){
        req=fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:JSON.parse(bundle.dataset.items)})});
      }else{
        var fd=new FormData(f);
        // Manda el input de cantidad; si está oculto, cae al tramo marcado del selector de volumen
        var qtyInput=f.querySelector('input[name="quantity"]');
        var qty=qtyInput?parseInt(qtyInput.value,10):0;
        if(!qty||qty<1){
          var volSel=document.querySelector('.fh-volume-option.is-selected');
          qty=volSel&&volSel.dataset.qty?parseInt(volSel.dataset.qty,10):1;
        }
        fd.set('quantity',String(qty));
        req=fetch('/cart/add.js',{method:'POST',body:fd});
      }
      req
        .then(function(r){
          if(!r.ok){throw new Error('add-failed')}
          return r.json();
        })
        .then(refreshCart)
        .then(function(){open('#CartDrawer')})
        .catch(function(){
          if(!btn)return;
          var prev=btn.innerHTML;
          btn.innerHTML='No se pudo añadir — inténtalo de nuevo';
          setTimeout(function(){btn.innerHTML=prev},2500);
        });
    };
    document.querySelectorAll('form[data-ajax-cart]').forEach(function(f){
      f.addEventListener('submit',function(e){e.preventDefault();fhAdd(f)});
    });

    // cart qty / remove — UNA sola petición: pedimos a Shopify que ya nos devuelva el
    // HTML del drawer renderizado (parámetro `sections`), en vez de change.js + un 2º fetch.
    // Quitar un kit entero (snippet fh-cart-kit): todas sus líneas a 0 por su key, en una petición
    document.addEventListener('click',function(e){
      var b=e.target.closest('[data-kit-remove]');if(!b)return;
      var up={};(b.dataset.keys||'').split(',').forEach(function(k){if(k)up[k]=0});
      var drawer=document.querySelector('#CartDrawer');
      if(drawer)drawer.classList.add('is-cart-updating');
      fetch('/cart/update.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({updates:up,sections:'cart-drawer',sections_url:window.location.pathname})
      })
        .then(function(r){return r.json()})
        .then(function(data){
          var html=data&&data.sections&&data.sections['cart-drawer'];
          if(html){applyCartHTML(html)}else{return refreshCart()}
        })
        .catch(function(){return refreshCart()})
        .then(function(){if(drawer)drawer.classList.remove('is-cart-updating')});
    });
    document.addEventListener('click',function(e){
      var b=e.target.closest('[data-line-change]');if(!b)return;
      var drawer=document.querySelector('#CartDrawer');
      if(drawer)drawer.classList.add('is-cart-updating'); // feedback inmediato + evita doble-clic
      fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({line:+b.dataset.line,quantity:+b.dataset.qty,sections:'cart-drawer',sections_url:window.location.pathname})
      })
        .then(function(r){return r.json()})
        .then(function(data){
          var html=data&&data.sections&&data.sections['cart-drawer'];
          if(html){applyCartHTML(html)}else{return refreshCart()}
        })
        .catch(function(){return refreshCart()})
        .then(function(){if(drawer)drawer.classList.remove('is-cart-updating')});
    });
  }

  // Precio tachado junto al precio del botón de compra / barra fija. text vacío = ocultar.
  // Con `base` fijamos el tachado propio de la variante para que el selector de volumen pueda
  // volver a él cuando el tramo no lleva descuento.
  window.fhSetCompare=function(text,base){
    document.querySelectorAll('[data-product-compare]').forEach(function(el){
      if(base!==undefined)el.dataset.base=base||'';
      var t=text==null?(el.dataset.base||''):text;
      el.textContent=t;el.style.display=t?'':'none';
    });
  };
  document.querySelectorAll('[data-product-compare]').forEach(function(el){el.dataset.base=el.textContent.trim()});

  // Stepper de cantidad en PDP. La cantidad es una sola: si además hay selector de volumen,
  // el stepper la manda y los tramos quedan marcados (o no) según coincidan.
  function fhApplyQty(input,qty){
    qty=Math.max(1,qty||1);
    input.value=qty;
    var vs=document.querySelector('fh-volume-selector');
    if(vs&&typeof vs.select==='function'){
      var tramo=vs.querySelector('input[type="radio"][value="'+qty+'"]');
      if(tramo){vs.select(String(qty))}
      else if(typeof vs.priceFor==='function'){
        vs.querySelectorAll('.fh-volume-option').forEach(function(o){o.classList.remove('is-selected')});
        vs.querySelectorAll('input[type="radio"]').forEach(function(r){r.checked=false});
        var t=vs.priceFor(qty);
        if(t)document.querySelectorAll('[data-product-price]').forEach(function(el){el.textContent=t});
        if(t&&typeof vs.compareFor==='function')fhSetCompare(vs.compareFor(qty));
      }
    }
    input.dispatchEvent(new Event('change',{bubbles:true}));
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-qty-minus],[data-qty-plus]');if(!b)return;
    var input=b.parentElement.querySelector('input[name="quantity"]');if(!input)return;
    var v=parseInt(input.value,10)||1;
    fhApplyQty(input,b.hasAttribute('data-qty-plus')?v+1:v-1);
  });
  document.addEventListener('input',function(e){
    var input=e.target;
    if(input.name!=='quantity'||!input.closest('form[data-product-form]'))return;
    var v=parseInt(input.value,10);
    if(v>0)fhApplyQty(input,v);
  });

  // selector de variantes
  document.querySelectorAll('[data-variant-picker]').forEach(function(picker){
    var jsonEl=picker.querySelector('[data-variant-json]');
    if(!jsonEl)return;
    var variants=JSON.parse(jsonEl.textContent);
    picker.addEventListener('click',function(e){
      var b=e.target.closest('[data-option-index]');if(!b)return;
      picker.querySelectorAll('[data-option-index="'+b.dataset.optionIndex+'"]').forEach(function(x){x.classList.remove('pill--active');x.setAttribute('aria-pressed','false')});
      b.classList.add('pill--active');b.setAttribute('aria-pressed','true');
      var sel=[];
      picker.querySelectorAll('.pill--active[data-option-index]').forEach(function(x){sel[+x.dataset.optionIndex]=x.dataset.optionValue});
      var match=null;
      for(var i=0;i<variants.length;i++){
        var ok=true;
        for(var j=0;j<variants[i].options.length;j++){if(variants[i].options[j]!==sel[j]){ok=false;break}}
        if(ok){match=variants[i];break}
      }
      if(!match)return;
      document.querySelectorAll('form[data-product-form] input[name="id"]').forEach(function(inp){inp.value=match.id});
      document.querySelectorAll('[data-product-price]').forEach(function(el){el.textContent=match.price});
      fhSetCompare(match.compare||'',match.compare||'');
      // la foto tiene que seguir a la variante: en difusores el color es la mitad de la decisión
      if(match.image){
        var mainImg=document.querySelector('#MainImage img');
        if(mainImg){
          mainImg.removeAttribute('srcset');mainImg.removeAttribute('sizes');
          mainImg.src=match.image;
          document.querySelectorAll('[data-thumb]').forEach(function(b){
            b.classList.toggle('is-active',b.getAttribute('data-full')===match.image);
          });
        }
      }
      document.querySelectorAll('[data-compare-wrap]').forEach(function(w){
        var cp=w.querySelector('[data-compare-price]'),sv=w.querySelector('[data-compare-save]');
        if(match.compare){w.style.display='flex';if(cp)cp.textContent=match.compare;if(sv)sv.textContent='Ahorras '+match.save}
        else{w.style.display='none'}
      });
      document.querySelectorAll('[data-buy-button]').forEach(function(btn){
        btn.disabled=!match.available;
        var label=btn.querySelector('[data-buy-label]');
        if(label){label.textContent=match.available?'Añadir al carrito':'Agotado'}
        var wrap=btn.querySelector('[data-price-wrap]');
        if(wrap){wrap.style.display=match.available?'':'none'}
      });
      if(window.history&&history.replaceState){
        var url=new URL(window.location.href);url.searchParams.set('variant',match.id);
        history.replaceState({},'',url.toString());
      }
    });
  });

  // quick-add en tarjetas de producto
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-quick-add]');if(!b)return;
    e.preventDefault();
    if(b.classList.contains('is-adding'))return;
    b.classList.add('is-adding');
    var isIcon=b.hasAttribute('data-quick-add-icon');
    var prev=b.textContent;
    if(!isIcon){b.textContent='Añadiendo…';}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:+b.dataset.variantId,quantity:1})})
      .then(function(r){if(!r.ok){throw new Error('add-failed')}return r.json()})
      .then(refreshCart)
      .then(function(){
        if(!isIcon){b.textContent='Añadido ✓';}
        b.classList.add('is-added');
        // Gusto «añadido»: desde una tarjeta, ✓ y saltito del contador sin tapar la página con el carrito
        if(!document.body.classList.contains('fh-g-anadido'))open('#CartDrawer');
        setTimeout(function(){if(!isIcon){b.textContent=prev;}b.classList.remove('is-added','is-adding')},1800);
      })
      .catch(function(){
        if(!isIcon){b.textContent='No disponible';}
        setTimeout(function(){if(!isIcon){b.textContent=prev;}b.classList.remove('is-adding')},2000);
      });
  });

  // apertura/cierre animados de acordeones <details class="acc"> (Web Animations API)
  // Se anima altura Y padding-bottom a la vez: con border-box, el padding hace de
  // suelo (la caja no baja de 24px) y animar solo la altura atasca el final del cierre.
  function slideAcc(d,body,opening){
    var expanded={height:body.offsetHeight+'px',paddingBottom:getComputedStyle(body).paddingBottom};
    var collapsed={height:'0px',paddingBottom:'0px'};
    body.style.overflow='hidden';
    var anim=body.animate(
      opening?[collapsed,expanded]:[expanded,collapsed],
      {duration:opening?400:320,easing:'cubic-bezier(.33,1,.68,1)'}
    );
    anim.onfinish=anim.oncancel=function(){
      if(!opening){d.open=false;d.classList.remove('acc-closing')}
      body.style.overflow='';
      delete d.dataset.anim;
    };
  }
  document.querySelectorAll('details.acc').forEach(function(d){
    var summary=d.querySelector('summary'),body=d.querySelector('.acc__body');
    if(!summary||!body)return;
    summary.addEventListener('click',function(e){
      e.preventDefault();
      if(d.dataset.anim)return;
      d.dataset.anim='1';
      if(d.open){
        d.classList.add('acc-closing'); // el icono vuelve a + desde el primer frame
        slideAcc(d,body,false);
      }else{
        d.classList.remove('acc-closing');
        d.open=true; // visible ya: la animación parte de 0 hacia la altura natural
        slideAcc(d,body,true);
      }
    });
  });

  // sliders horizontales (colecciones destacadas)
  document.querySelectorAll('[data-fh-slider]').forEach(function(wrap){
    var track=wrap.querySelector('.fh-slider');
    var prev=wrap.querySelector('.fh-slider-arrow--prev'),next=wrap.querySelector('.fh-slider-arrow--next');
    if(!track||!prev||!next)return;
    function step(){var card=track.firstElementChild;return card?card.getBoundingClientRect().width+24:300}
    function update(){
      prev.disabled=track.scrollLeft<10;
      next.disabled=track.scrollLeft>track.scrollWidth-track.clientWidth-10;
    }
    var beh=reducedMotion?'auto':'smooth';
    prev.addEventListener('click',function(){track.scrollBy({left:-step()*2,behavior:beh})});
    next.addEventListener('click',function(){track.scrollBy({left:step()*2,behavior:beh})});
    track.addEventListener('scroll',update,{passive:true});
    update();
  });

  // vídeos que reproducen solo en viewport (feature-objeciones)
  if('IntersectionObserver' in window){
    var vio=new IntersectionObserver(function(en){en.forEach(function(e){
      var v=e.target.querySelector('video');if(!v)return;
      if(e.isIntersecting){if(!reducedMotion){var pr=v.play();if(pr&&pr.catch)pr.catch(function(){})}}else{v.pause()}
    })},{rootMargin:'80px'});
    document.querySelectorAll('[data-io-video]').forEach(function(el){vio.observe(el)});
  }

  // animación Etnalia: cargar solo cerca del viewport y respetar movimiento reducido
  // (data-fh-anim-always = sustituye a un GIF, que se movía siempre → reproduce también con RM)
  document.querySelectorAll('[data-fh-lazy-video]').forEach(function(video){
    if(reducedMotion&&!video.hasAttribute('data-fh-anim-always'))return;
    function loadVideo(){
      if(video.dataset.loaded)return;
      video.querySelectorAll('source[data-src]').forEach(function(source){source.src=source.dataset.src});
      video.dataset.loaded='true';
      video.load();
    }
    function playVideo(){loadVideo();var promise=video.play();if(promise&&promise.catch)promise.catch(function(){})}
    if(!('IntersectionObserver' in window)){playVideo();return}
    var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){
      if(entry.isIntersecting){playVideo()}else{video.pause()}
    })},{rootMargin:'200px'});
    observer.observe(video);
  });

  // swap de tarjeta ex-GIF: el mp4 solo se descarga y reproduce al hacer hover (en móvil no hay hover → no se descarga)
  document.addEventListener('mouseover',function(e){
    var card=e.target.closest&&e.target.closest('.product-card');if(!card)return;
    var v=card.querySelector('video[data-fh-swap-video]');if(!v)return;
    if(!v.dataset.loaded){v.querySelectorAll('source[data-src]').forEach(function(s){s.src=s.dataset.src});v.dataset.loaded='true';v.load()}
    var p=v.play();if(p&&p.catch)p.catch(function(){});
  });
  document.addEventListener('mouseout',function(e){
    var card=e.target.closest&&e.target.closest('.product-card');if(!card)return;
    if(e.relatedTarget&&card.contains(e.relatedTarget))return;
    var v=card.querySelector('video[data-fh-swap-video]');if(v&&v.pause)v.pause();
  });

  // pista de scroll en contenedores anchos (tablas comparativas)
  document.querySelectorAll('[data-scroll-hint]').forEach(function(sc){
    function upd(){sc.toggleAttribute('data-overflow',sc.scrollWidth-sc.clientWidth>4)}
    upd();sc.addEventListener('scroll',function(){if(sc.scrollLeft>4)sc.removeAttribute('data-overflow')},{passive:true});
    window.addEventListener('resize',upd);
  });

  // sticky buy bar (oculta el widget de WhatsApp en móvil mientras está visible)
  // trigger = primer botón de compra que NO esté dentro de la propia barra
  // (en PDP legacy Be Yours el botón es button[name="add"], no [data-buy-button])
  var bar=document.querySelector('[data-sticky-bar]'),trigger=null;
  if(bar){
    var trigCands=document.querySelectorAll('[data-buy-button],button[name="add"],form[action*="/cart/add"] [type="submit"]');
    for(var ti=0;ti<trigCands.length;ti++){if(!bar.contains(trigCands[ti])){trigger=trigCands[ti];break}}
  }
  // en la preview de Shopify, la barra "Draft" tapa el CTA — súbelo por encima
  // (el iframe de preview se inyecta tarde, así que se re-comprueba tras cargar)
  if(bar){
    var liftForPreviewBar=function(){if(document.getElementById('preview-bar-iframe')||document.getElementById('PBarNextFrameWrapper'))bar.style.bottom='96px'};
    liftForPreviewBar();window.addEventListener('load',function(){setTimeout(liftForPreviewBar,600)});
  }
  if(bar&&trigger){
    // Se recalcula en cada scroll con la posición REAL del botón (no solo con los cruces
    // del IntersectionObserver): en Safari iOS el IO se saltaba un cruce al cambiar el
    // viewport (barra de direcciones), y la barra dejaba de reaparecer tras volver a salir
    // el botón de WhatsApp. Mostrar cuando el botón ya se ha pasado hacia arriba.
    var setSticky=function(){
      if(!bar.isConnected){document.body.classList.remove('sticky-bar-on');return}
      var show=trigger.getBoundingClientRect().bottom<80;
      bar.style.transform=show?'none':'translateY(150%)';
      document.body.classList.toggle('sticky-bar-on',show);
    };
    var stickyTicking=false;
    var onStickyScroll=function(){if(stickyTicking)return;stickyTicking=true;requestAnimationFrame(function(){setSticky();stickyTicking=false})};
    window.addEventListener('scroll',onStickyScroll,{passive:true});
    window.addEventListener('resize',onStickyScroll,{passive:true});
    setSticky();
  }

  // píldora "sale hoy" con contador + fecha de entrega estimada
  function pad(n){return (n<10?'0':'')+n}
  function addBiz(date,n){var x=new Date(date);while(n>0){x.setDate(x.getDate()+1);var w=x.getDay();if(w!==0&&w!==6)n--}return x}
  document.querySelectorAll('[data-ships-today]').forEach(function(el){
    var label=el.querySelector('[data-ships-label]'),t;
    // Quién decide si sale hoy es el servidor (hora de la tienda + festivos), no este reloj.
    var saleHoy=el.dataset.saleHoy==='true';
    function tick(){
      var now=new Date(),before=saleHoy&&now.getHours()<16;
      if(before){
        var end=new Date(now);end.setHours(16,0,0,0);var diff=end-now;
        var h=Math.floor(diff/36e5),m=Math.floor(diff%36e5/6e4),s=Math.floor(diff%6e4/1e3);
        label.innerHTML='Sale hoy si lo pides en <strong style="font-variant-numeric:tabular-nums">'+h+'h '+pad(m)+'m '+pad(s)+'s</strong>';
      }else{
        label.textContent='Sale el próximo día laborable';
        if(t){clearInterval(t);t=null}
      }
    }
    tick();
    if(saleHoy&&new Date().getHours()<16){t=setInterval(tick,1000)}
  });
  document.querySelectorAll('[data-delivery-date]').forEach(function(el){
    var now=new Date();
    var pill=document.querySelector('[data-ships-today]');
    var hoy=pill?pill.dataset.saleHoy==='true':false;
    var dispatch=hoy?now:addBiz(now,1);
    var deliver=addBiz(dispatch,4);
    try{el.textContent=deliver.toLocaleDateString('es-ES',{day:'numeric',month:'long'})}
    catch(e){el.textContent=pad(deliver.getDate())+'/'+pad(deliver.getMonth()+1)}
  });

  // Buscador: placeholder rotativo + intenciones ("dormir mejor" → Dulces Sueños) + predictivo.
  // Los datos (sinónimos, productos, lista negra médica) viven en fh-intents.js,
  // generado desde BUSCADOR_INTENCIONES.md — ese doc manda.
  var searchBox=document.querySelector('.fh-search');
  var searchInput=document.querySelector('[data-search-input]');
  var searchResults=document.querySelector('[data-search-results]');
  var INT=window.FH_INTENTS||null;
  var escH=function(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;')};
  // sin acentos ni ñ, para que "sueño"/"niños" matcheen con las raíces del mapa
  var normQ=function(s){return String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9 ]+/g,' ').replace(/\s+/g,' ').trim()};
  var hasRoot=function(toks,q,root){
    if(root.indexOf(' ')>=0)return q.indexOf(root)>=0;
    for(var i=0;i<toks.length;i++){if(toks[i].indexOf(root)===0)return true}
    return false;
  };
  function classifyQuery(qRaw){
    if(!INT)return{type:'none'};
    var q=normQ(qRaw),toks=q.split(' '),i;
    for(i=0;i<INT.blacklist.length;i++){if(hasRoot(toks,q,INT.blacklist[i]))return{type:'medic'}}
    var grey=null;
    for(i=0;i<INT.grey.length;i++){if(INT.grey[i].words.some(function(w){return hasRoot(toks,q,w)})){grey=INT.grey[i];break}}
    var intent=null,best=0;
    INT.intents.forEach(function(it){
      var score=0;
      it.syn.forEach(function(w){if(hasRoot(toks,q,w))score+=(w.indexOf(' ')>=0?2:1)});
      if(score>best){best=score;intent=it}
    });
    if(!intent&&grey){intent=INT.intents.filter(function(it){return it.id===grey.intent})[0]}
    if(!intent)return{type:'none'};
    var mod=null;
    for(i=0;i<INT.modifiers.length;i++){if(INT.modifiers[i].words.some(function(w){return hasRoot(toks,q,w)})){mod=INT.modifiers[i];break}}
    return{type:'intent',intent:intent,mod:mod,grey:grey};
  }
  // Destacado: las páginas no salen en el predictivo de Shopify; si la búsqueda lleva
  // «difusor», «suscripción»… la tarjeta de la suscripción sale la primera.
  var PROMO=null;try{var pe=document.getElementById('fh-search-promo');if(pe)PROMO=JSON.parse(pe.textContent)}catch(e){}
  function promoHtml(qRaw){
    if(!PROMO||!PROMO.u)return'';
    var q=normQ(qRaw),toks=q.split(' ');
    var hit=PROMO.w.some(function(w){w=normQ(w);return w&&hasRoot(toks,q,w)});
    if(!hit)return'';
    var img=PROMO.i?'<img src="'+escH(PROMO.i)+'" alt="" style="width:52px;height:64px;object-fit:cover;border-radius:10px;background:#fff;flex:none">':'';
    return '<a href="'+escH(PROMO.u)+'" class="fh-search__promo" style="display:flex;gap:14px;align-items:center;padding:12px;margin:4px 0 10px;border-radius:16px;background:var(--surface);border:1px solid var(--hairline)">'+img+'<span style="flex:1;min-width:0"><span style="display:block;font-size:14.5px;font-weight:600;line-height:1.3;color:var(--navy)">'+escH(PROMO.t)+'</span>'+(PROMO.d?'<span style="display:block;font-size:12.5px;color:var(--soft);margin-top:3px;line-height:1.4">'+escH(PROMO.d)+'</span>':'')+'</span><span style="color:var(--navy);font-weight:600">→</span></a>';
  }
  var prodCache={};
  function fetchIntentProducts(handles,cb){
    handles=handles.slice(0,8);
    var results=new Array(handles.length),pending=0;
    handles.forEach(function(h,i){
      if(prodCache[h]){results[i]=prodCache[h];return}
      pending++;
      fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null}).then(function(p){
        if(p){prodCache[h]=p;results[i]=p}
        if(--pending===0)cb(results.filter(Boolean));
      }).catch(function(){if(--pending===0)cb(results.filter(Boolean))});
    });
    if(pending===0)cb(results.filter(Boolean));
  }
  // Índice propio (sections/fh-buscador-datos): nombre, precio, foto y «Huele a» de todo lo que se vende.
  // Se pide la primera vez que se abre el buscador; con él la respuesta sale al teclear, sin esperar a Shopify.
  var IDX=null,IDXby={},idxReq=null;
  var HUELE=(searchBox&&searchBox.getAttribute('data-huele'))||'';
  function loadIdx(){
    if(idxReq||!searchBox)return idxReq;
    idxReq=fetch('/?section_id=fh-buscador-datos').then(function(r){return r.text()}).then(function(t){
      var m=t.match(/<script[^>]*id="fh-bd"[^>]*>([\s\S]*?)<\/script>/);if(!m)return;
      IDX=JSON.parse(m[1]);
      IDX.forEach(function(o){IDXby[o.h]=o;o.n=normQ(o.t+' '+(o.o||'')+' '+(o.k||''));o.nt=normQ(o.t)});
      if(searchInput&&searchInput.value.trim().length>=2)searchInput.dispatchEvent(new Event('input'));
    }).catch(function(){idxReq=null});
    return idxReq;
  }
  // al ir a abrir el buscador (pasar el ratón, tocar) ya se pide; así está listo cuando escribes
  document.addEventListener('pointerdown',function(e){if(e.target.closest('[data-open="#SearchModal"]'))loadIdx()},true);
  document.addEventListener('mouseover',function(e){if(e.target.closest&&e.target.closest('[data-open="#SearchModal"]'))loadIdx()},{passive:true});
  if(searchInput)searchInput.addEventListener('focus',loadIdx);
  var money=function(c){return (c/100).toFixed(2).replace('.',',')+' €'};
  var handleOf=function(u){return String(u||'').split('/products/')[1]?String(u).split('/products/')[1].split(/[?#]/)[0]:''};
  // Una fila de resultado: foto, nombre, «Huele a …» si es un aceite, precio
  function row(o){
    var im=o.i?String(o.i):'';
    if(/\.gif(\?|$)/i.test(im))im='';
    var img=im?'<img src="'+escH(im)+'" alt="" loading="lazy" width="52" height="64">':'<span></span>';
    var ol=(HUELE&&o.o)?'<span class="fh-sr__ol"><b>'+escH(HUELE)+'</b> '+escH(o.o)+'</span>':'';
    return '<a href="'+escH(o.u)+'" class="fh-sr'+(o.a===0?' is-out':'')+'"><span class="fh-sr__img">'+img+'</span><span class="fh-sr__b"><span class="fh-sr__t">'+escH(o.t)+'</span>'+ol+'</span><span class="fh-sr__p">'+(o.a===0?'Agotado':escH(o.pf||money(o.p)))+'</span></a>';
  }
  function rowFromProduct(p){
    var x=IDXby[p.handle]||IDXby[handleOf(p.url)];
    if(x)return row(x);
    var im=p.featured_image?String(p.featured_image):'';
    if(/\.gif(\?|$)/i.test(im)&&p.images){for(var gi=0;gi<p.images.length;gi++){if(!/\.gif(\?|$)/i.test(String(p.images[gi]))){im=String(p.images[gi]);break}}}
    if(im)im+=(im.indexOf('?')>=0?'&':'?')+'width=120';
    return row({u:p.url,t:p.title,i:im,p:p.price,a:p.available===false?0:1});
  }
  // Búsqueda local: cada palabra tiene que empezar alguna palabra del producto; el nombre pesa más
  function localSearch(q){
    if(!IDX)return null;
    var toks=normQ(q).split(' ').filter(Boolean);if(!toks.length)return[];
    var out=[];
    IDX.forEach(function(o){
      var words=o.n.split(' '),tw=o.nt.split(' '),score=0;
      for(var i=0;i<toks.length;i++){
        var t=toks[i],hit=false,inT=false;
        for(var w=0;w<words.length;w++){if(words[w].indexOf(t)===0){hit=true;break}}
        if(!hit)return;
        for(var v=0;v<tw.length;v++){if(tw[v].indexOf(t)===0){inT=true;break}}
        score+=inT?3:1;
      }
      if(o.nt.indexOf(normQ(q))===0)score+=4;
      if(o.a)score+=2;
      out.push({o:o,s:score});
    });
    out.sort(function(a,b){return b.s-a.s||a.o.t.length-b.o.t.length});
    return out.slice(0,8).map(function(x){return x.o});
  }
  // Últimas búsquedas (solo en este navegador)
  var RKEY='fh-busquedas';
  function recentGet(){try{return JSON.parse(localStorage.getItem(RKEY)||'[]')}catch(e){return[]}}
  function recentSave(q){
    q=String(q||'').trim();if(q.length<2)return;
    var l=recentGet().filter(function(x){return normQ(x)!==normQ(q)});l.unshift(q);
    try{localStorage.setItem(RKEY,JSON.stringify(l.slice(0,4)))}catch(e){}
    paintRecent();
  }
  window.fhSearchRecent=recentSave;
  function paintRecent(){
    var box=document.querySelector('[data-search-recent]'),list=box&&box.querySelector('[data-search-recent-list]');if(!list)return;
    var l=recentGet();box.hidden=!l.length;
    list.innerHTML=l.map(function(q){return '<button type="button" class="fh-search__rchip" data-recent-q="'+escH(q)+'"><svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="6.2" stroke="currentColor" stroke-width="1.3"/><path d="M8 4.8V8l2.2 1.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>'+escH(q)+'</button>'}).join('');
  }
  paintRecent();
  document.addEventListener('click',function(e){
    var c=e.target.closest('[data-recent-q]');
    if(c&&searchInput){searchInput.value=c.getAttribute('data-recent-q');searchInput.dispatchEvent(new Event('input'));searchInput.focus();return}
    if(e.target.closest('[data-search-recent-clear]')){try{localStorage.removeItem(RKEY)}catch(x){}paintRecent();return}
    // quien toca un resultado se guarda lo que había escrito
    if(searchInput&&e.target.closest('[data-search-results] a')&&searchInput.value.trim().length>=2)recentSave(searchInput.value);
  });
  function bindChips(container,isPage){
    container.querySelectorAll('[data-intent-chip]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var id=btn.getAttribute('data-intent-chip');
        if(isPage){window.location='/search?q='+encodeURIComponent(btn.textContent.trim().toLowerCase());return}
        if(searchInput){searchInput.value=btn.textContent.trim().toLowerCase();searchInput.dispatchEvent(new Event('input'))}
      });
    });
  }
  // Pinta el resultado de intención/aviso en `container`. Devuelve false si la query
  // no matchea nada (el caller decide el fallback: predictivo en el modal, nada en /search).
  function renderIntentQuery(qRaw,container,isPage){
    var c=classifyQuery(qRaw);
    if(c.type==='medic'){container.innerHTML=INT.blacklistHtml;bindChips(container,isPage);return true}
    if(c.type!=='intent')return false;
    var handles=c.intent.products.slice();
    if(c.mod){
      var sp=handles.filter(function(h){return INT.sprays.indexOf(h)>=0});
      var rest=handles.filter(function(h){return INT.sprays.indexOf(h)<0});
      handles=sp.concat(rest);
    }
    var prefix='<div class="fh-search__intent-label">'+escH(c.intent.label)+'</div>';
    if(c.mod)prefix+='<div class="fh-search__banner">'+escH(c.mod.banner)+'</div>';
    if(c.grey)prefix+='<div class="fh-search__greynote">'+escH(INT.greyNote)+'</div>';
    var paint=function(ps){
      if(!ps.length){container.innerHTML=isPage?'':promoHtml(qRaw);return}
      var html=(isPage?'':promoHtml(qRaw))+prefix+'<div data-search-grid>'+ps.map(rowFromProduct).join('')+'</div>';
      if(!isPage)html+='<a href="/search?q='+encodeURIComponent(qRaw)+'" style="display:block;text-align:center;padding:14px 0 4px;font-size:12.5px;font-weight:600;color:var(--navy);text-decoration:underline;text-underline-offset:4px">Ver todos los resultados</a>';
      container.innerHTML=html;
    };
    if(IDX){paint(handles.map(function(h){return IDXby[h]}).filter(function(o){return o&&o.a}).slice(0,8).map(function(o){return {handle:o.h,url:o.u,title:o.t,price:o.p}}))}
    else fetchIntentProducts(handles,paint);
    return true;
  }
  // Placeholder rotativo: mismas frases en el modal y en la píldora del header,
  // con fundido (sin desplazamiento — amable con "reducir movimiento").
  var phrases=[];
  try{phrases=JSON.parse((searchBox&&searchBox.getAttribute('data-search-phrases'))||'[]')}catch(e){}
  var phEl=document.querySelector('[data-ph-rotator]');
  // querySelectorAll: hay más de una píldora con frase (header desktop + menú móvil)
  var pillEls=document.querySelectorAll('[data-header-phrase]');
  if(pillEls.length&&phrases.length)pillEls.forEach(function(el){el.textContent=phrases[0]});
  if(phrases.length>1&&(phEl||pillEls.length)){
    var phIdx=0;
    setInterval(function(){
      if(document.hidden)return;
      if(phEl)phEl.classList.add('is-fading');
      pillEls.forEach(function(el){el.classList.add('is-fading')});
      setTimeout(function(){
        phIdx=(phIdx+1)%phrases.length;
        if(phEl){phEl.textContent=phrases[phIdx];phEl.classList.remove('is-fading')}
        pillEls.forEach(function(el){el.textContent=phrases[phIdx];el.classList.remove('is-fading')});
      },470);
    },3500);
  }
  if(searchInput&&searchResults){
    var searchTimer;
    var searchForm=searchInput.closest('form');
    if(searchForm){
      searchForm.addEventListener('reset',function(){
        clearTimeout(searchTimer);
        searchResults.innerHTML='';
        searchForm.classList.remove('has-value');
        if(searchBox)searchBox.classList.remove('has-results');
        setTimeout(function(){searchInput.focus()},0);
      });
    }
    if(searchForm)searchForm.addEventListener('submit',function(){recentSave(searchInput.value)});
    var lastQ='',sugSeq=0;
    var verTodo=function(q){return '<a href="/search?q='+encodeURIComponent(q)+'" class="fh-sr__all">Ver todos los resultados</a>'};
    searchInput.addEventListener('input',function(){
      clearTimeout(searchTimer);
      var q=searchInput.value.trim();
      if(searchForm)searchForm.classList.toggle('has-value',searchInput.value.length>0);
      if(q.length<2){searchResults.innerHTML='';lastQ='';if(searchBox)searchBox.classList.remove('has-results');paintRecent();return}
      if(searchBox)searchBox.classList.add('has-results');
      lastQ=q;
      if(renderIntentQuery(q,searchResults,false))return;
      // 1) al instante, con el índice propio
      var loc=localSearch(q),seq=++sugSeq;
      if(loc&&loc.length)searchResults.innerHTML=promoHtml(q)+'<div data-search-grid>'+loc.map(row).join('')+'</div>'+verTodo(q);
      // 2) después, lo que añada el buscador de Shopify (erratas, descripciones)
      searchTimer=setTimeout(function(){
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide')
          .then(function(r){return r.json()})
          .then(function(data){
            if(seq!==sugSeq)return; // ya escribió otra cosa
            var prods=(data.resources&&data.resources.results&&data.resources.results.products)||[];
            // Los productos internos (regalos de suscripción, líneas de envío) no se venden
            // sueltos: tampoco deben aparecer al buscar. "regalo" los sacaba los primeros.
            var internos=(document.body.dataset.fhInternos||'').split(',');
            prods=prods.filter(function(p){return internos.indexOf(handleOf(p.url))===-1});
            var seen={},list=(loc||[]).slice();
            list.forEach(function(o){seen[o.h]=1});
            var added=0;
            prods.forEach(function(p){
              var h=handleOf(p.url);if(seen[h])return;seen[h]=1;added++;
              var x=IDXby[h];
              list.push(x||{h:h,u:p.url,t:p.title,i:p.featured_image&&p.featured_image.url?p.featured_image.url+'&width=120':'',pf:p.price?String(p.price).replace('.',',')+' €':'',a:1});
            });
            if(loc&&loc.length&&!added)return; // nada nuevo: no repintamos (sin parpadeo)
            var promo=promoHtml(q);
            if(!list.length){searchResults.innerHTML=promo||'<div class="fh-sr__none">No hemos encontrado nada para «'+escH(q)+'»</div>';return}
            searchResults.innerHTML=promo+'<div data-search-grid>'+list.slice(0,8).map(row).join('')+'</div>'+verTodo(q);
          }).catch(function(){});
      },IDX?160:120);
    });
  }
  // Página /search: mismo motor sobre la query enviada (bloque de intención o aviso
  // médico encima de los resultados estándar)
  var searchPageBox=document.querySelector('[data-search-page]');
  var searchPromoBox=document.querySelector('[data-search-promo-page]');
  if(searchPromoBox&&searchPageBox&&searchPageBox.getAttribute('data-q'))searchPromoBox.innerHTML=promoHtml(searchPageBox.getAttribute('data-q'));
  if(searchPageBox&&searchPageBox.getAttribute('data-q')){
    renderIntentQuery(searchPageBox.getAttribute('data-q'),searchPageBox,true);
  }
})();

// "Leer más" pegajoso en reseñas Judge.me: el widget re-renderiza (paginación por
// scroll, resize, relayout) y vuelve a truncar las reseñas ya expandidas. Al expandir
// guardamos el HTML completo del cuerpo y lo restauramos si el widget lo re-trunca.
// No re-clicamos el enlace: en algunos casos "Leer más" navega al producto en vez de
// expandir inline, y un click programático podría navegar sin interacción del usuario.
(function(){
  if(window.__fhRevSticky)return;window.__fhRevSticky=1;
  var expanded={};
  document.addEventListener('click',function(e){
    var link=e.target&&e.target.closest&&e.target.closest('.jdgm-rev__body-read-more');
    if(!link)return;
    var rev=link.closest('.jdgm-rev');
    var id=rev&&rev.dataset.reviewId;
    if(!id)return;
    setTimeout(function(){
      var body=rev.querySelector('.jdgm-rev__body');
      if(body&&!body.classList.contains('is-truncated'))expanded[id]=body.innerHTML;
    },0);
  },true);
  var raf=null;
  new MutationObserver(function(){
    if(raf)return;
    raf=requestAnimationFrame(function(){
      raf=null;
      for(var id in expanded){
        var body=document.querySelector('.jdgm-rev[data-review-id="'+id+'"] .jdgm-rev__body.is-truncated');
        if(!body)continue;
        body.innerHTML=expanded[id];
        body.classList.remove('is-truncated');
      }
    });
  }).observe(document.body,{childList:true,subtree:true});
})();

/* Vídeos: bucle corto mudo (teaser) y salto a reproducción completa con sonido.
   El navegador solo permite autoplay si el vídeo va mudo, de ahí el bucle silencioso;
   el sonido se activa con el clic del usuario, que sí es un gesto válido. */
(function(){
  document.querySelectorAll('[data-fh-video]').forEach(function(wrap){
    var v=wrap.querySelector('video');
    if(!v)return;
    var end=parseFloat(wrap.dataset.loopEnd||'5');
    var teaser=wrap.dataset.mode==='teaser';
    v.muted=true;v.playsInline=true;v.setAttribute('playsinline','');
    var playing=false;

    if(teaser&&end>0){
      v.addEventListener('timeupdate',function(){
        if(!playing&&v.currentTime>=end)v.currentTime=0;
      });
    }
    // no gastar batería ni datos con el vídeo fuera de pantalla
    if('IntersectionObserver'in window){
      new IntersectionObserver(function(e){
        if(playing)return;
        if(e[0].isIntersecting){var p=v.play();if(p&&p.catch)p.catch(function(){})}
        else v.pause();
      },{threshold:.15}).observe(wrap);
    }

    var btn=wrap.querySelector('[data-fh-video-play]');
    if(btn){
      btn.addEventListener('click',function(){
        playing=true;
        wrap.classList.add('is-playing');
        v.loop=false;v.muted=false;v.controls=true;v.currentTime=0;
        var p=v.play();if(p&&p.catch)p.catch(function(){});
      });
      // al acabar, vuelve al bucle mudo: la página no se queda con un fotograma negro
      v.addEventListener('ended',function(){
        playing=false;
        wrap.classList.remove('is-playing');
        v.controls=false;v.muted=true;v.loop=true;v.currentTime=0;
        var p=v.play();if(p&&p.catch)p.catch(function(){});
      });
    }
  });

  // YouTube/Vimeo: el iframe se carga solo al pulsar (portada estática hasta entonces)
  document.querySelectorAll('[data-fh-embed]').forEach(function(wrap){
    var btn=wrap.querySelector('[data-fh-embed-play]');
    if(!btn)return;
    btn.addEventListener('click',function(){
      var id=wrap.dataset.id,prov=wrap.dataset.provider;
      var src=prov==='vimeo'
        ? 'https://player.vimeo.com/video/'+id+'?autoplay=1'
        : 'https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0';
      var f=document.createElement('iframe');
      f.src=src;f.title='Vídeo';f.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      f.allowFullscreen=true;f.style.cssText='position:absolute;inset:0;width:100%;height:100%;border:0';
      wrap.appendChild(f);
      wrap.classList.add('is-playing');
    });
  });
})();

/* Punto verde de «Sale hoy»: late 4 veces cuando aparece en pantalla, no siempre (21-oct-2026) */
(function(){
  var dots=document.querySelectorAll('.ships-dot');
  if(!dots.length)return;
  if(!('IntersectionObserver' in window)){dots.forEach(function(d){d.classList.add('is-live')});return}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-live');io.unobserve(e.target)}})});
  dots.forEach(function(d){io.observe(d)});
})();
